import { useAuth } from '../../context/AuthContext'
import { tieneFuncionComercial } from '../../components/espacios'
import ComercialPermisosTabla from '../../components/comercial/ComercialPermisosTabla'

// Comercial > Administración > Permisos: who holds each Comercial function
// (backend comercial_permisos.py, its own tables). Takes "comercial_permisos".
// Unlike the OT's, platform roles are regular holders here, and the admin
// role's assignments are locked (it keeps every function).
export default function ComercialPermisos() {
  const { user } = useAuth()
  return <ComercialPermisosTabla puede={tieneFuncionComercial(user, 'comercial_permisos')} />
}
